import api from '../../../App/socket';

export const getLeadOMConfig = () => (
    api.send({
        api: 'db',
        model: 'Leadomatic_configuration',
        action: 'Read',
        options: {
            attributes: 'all',
            limit: 1,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/requests/get_leadom_config_request.js